import BlogPost1 from "./BlogPost1.jsx";
import BlogPost2 from "./BlogPost2.jsx";
import BlogPost3 from "./BlogPost3.jsx";
import BlogPost4 from "./BlogPost4.jsx";
import BlogPost5 from "./BlogPost5.jsx";
import BlogPost6 from "./BlogPost6.jsx";
import BlogPost7 from "./BlogPost7.jsx";
import BlogPost8 from "./BlogPost8.jsx";
import BlogPost9 from "./BlogPost9.jsx";
import BlogPost10 from "./BlogPost10.jsx";
import BlogPost11 from "./BlogPost11.jsx";
import BlogPost12 from "./BlogPost12.jsx";
import BlogPost13 from "./BlogPost13.jsx";
import BlogPost14 from "./BlogPost14.jsx";
import BlogPost15 from "./BlogPost15.jsx";
import BlogPost16 from "./BlogPost16.jsx";
import BlogPost17 from "./BlogPost17.jsx";
import BlogPost18 from "./BlogPost18.jsx";
import BlogPost19 from "./BlogPost19.jsx";
import BlogPost20 from "./BlogPost20.jsx";
import BlogPost21 from "./BlogPost21.jsx";
import BlogPost22 from "./BlogPost22.jsx";
import BlogPost23 from "./BlogPost23.jsx";

const posts = [
  BlogPost1,
  BlogPost2,
  BlogPost3,
  BlogPost4,
  BlogPost5,
  BlogPost6,
  BlogPost7,
  BlogPost8,
  BlogPost9,
  BlogPost10,
  BlogPost11,
  BlogPost12,
  BlogPost13,
  BlogPost14,
  BlogPost15,
  BlogPost16,
  BlogPost17,
  BlogPost18,
  BlogPost19,
  BlogPost20,
  BlogPost21,
  BlogPost22,
  BlogPost23,
];

export default posts;
